export default __webpack_public_path__ + "static/media/romy.81cbebbc.jpeg";